import React from 'react'
import { BConnector } from '../../../types/stations.types';
import { useSingleConnectorV2 } from '../../../hooks/useConnectors';

import { dateConverter } from '../../../../../utils/dateConverter';

import {JWayIconConnectorConverter} from '../../../utils/iconConverterConnector';
export interface ConnectorInfoProps {
  info: keyof BConnector | 'connector_icon';
  id?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  size?: number;
  color?: string;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    item?: unknown;
    value?: unknown;

    goTo: () => void;
  }) => JSX.Element;
}




export default function SingleConnectorInfo({info, id, emptyText, renderComponent, size= 30, color= 'gray'}: ConnectorInfoProps) {

    const {singleConnectorQuery} = useSingleConnectorV2({connectorId: id});

    if (singleConnectorQuery.isLoading) return <>...</>;
    if (singleConnectorQuery.isError) return <>{emptyText ||''}</>;


        const convertValue = (info: keyof BConnector , value: any) => {
          switch (info) {
            case "b_connector_created_at":
              return dateConverter(value);
            case "b_connector_updated_at":
                return dateConverter(value);
            default:
              return value;
          }
        };

        if (info === 'connector_icon') {
        
          return <>{JWayIconConnectorConverter(singleConnectorQuery.data?.b_connector_type || null , size, color)}</>
          
        }

        if (renderComponent) {
            return renderComponent({
              labelRender: convertValue(info, singleConnectorQuery?.data?.[info]),
              item: singleConnectorQuery?.data,
              value: singleConnectorQuery?.data?.[info],
              goTo: () => {},
            });
          }

          
  return (
    <>
            {convertValue(info, singleConnectorQuery?.data?.[info])}
    </>
  )
}


